import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { ScrollProgress } from "@/components/landing/ScrollProgress";
import { HomePage } from "@/pages/HomePage";
import { ServicesPage } from "@/pages/ServicesPage";
import { AboutPage } from "@/pages/AboutPage";
import { ContactPage } from "@/pages/ContactPage";

const AppRoutes = () => (
  <div className="min-h-screen overflow-x-clip bg-[#050606] text-white antialiased">
    <ScrollProgress />
    <Header />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/servicos" element={<ServicesPage />} />
      <Route path="/sobre" element={<AboutPage />} />
      <Route path="/contato" element={<ContactPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
    <Footer />
    <Toaster position="bottom-center" theme="dark" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
